import { Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Hero from "./components/Hero";
import CardsSection from "./components/CardsSection";
import FullWidthCard from "./components/FullWidthCard";
import IconSlider from "./components/IconSlider";
import MostLovedRecipes from "./components/MostLovedRecipes";
import SingleServeCookies from "./components/SingleServeCookies";
import LetsConnect from "./components/LetsConnect";
import Leaderboard from "./components/Leaderboard";
import ShopMyFavourites from "./components/ShopMyFavourites";
import Footer from "./components/Footer";

// NEW
import Contact from "./pages/Contact";
import About from "./pages/About";
import Shop from "./pages/Shop";
import Recipe from "./pages/Recipe";
const App = () => {
  return (
    <>
      <Header />

      <Routes>
        {/* HOME PAGE */}
        <Route
          path="/"
          element={
            <>
              <Hero />
              <CardsSection />
              <FullWidthCard />
              <IconSlider />
              {/* <MostLovedRecipes /> */}
              <SingleServeCookies />
              <LetsConnect />
              <Leaderboard />
              <ShopMyFavourites />
            </>
          }
        />

        {/* ABOUT PAGE */}
        <Route path="/Contact" element={<Contact />} />
         <Route path="/About" element={<About />} />
        <Route path="/shop" element={<Shop />} />
           <Route path="/recipes/:slug" element={<Recipe />} />
      </Routes>

      <Footer />
    </>
  );
};

export default App;
